exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".po-promotion-icon{float:left;width:50px;z-index:1;margin:-9px 0 0 -3px}.po-promotion-card-body{-ms-flex:1 1 auto;flex:1 1 auto;padding:.5rem}.po-promotion-imageinside{object-fit:contain;width:373px;padding:.25rem;transition:all .2s ease-in-out}.fade-enter-active,.fade-leave-active{transition:opacity .5s}.fade-enter,.fade-leave-to{opacity:0}.po-table{width:100%;max-width:100%;table-layout:fixed}.po-table-td{padding:0;vertical-align:top;border-top:1px solid #cfd8dc}.po-card-body{flex:1 1 auto;padding:0 1.25rem 1.25rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1faf2d7d","scoped":false,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/offers/Offer.vue
// module id = 423
// module chunks = 1